import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { selectFiltersValue } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { tableFiltersChangedAction } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/action-creators";
import { selectTableFilters } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { ContactsSearchTableFilters } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

const useContactFilterResetting = (): void => {
    const dispatch = useDispatch();
    const filterValues = useSelector(selectFiltersValue);
    const { pageSize }: ContactsSearchTableFilters = useSelector(selectTableFilters);
    useEffect(() => {
        dispatch(tableFiltersChangedAction({ page: 1, pageSize }));
    }, [dispatch, filterValues]);
};

export default useContactFilterResetting;
